module.exports = __webpack_public_path__ + "img/3.3be46e0e.jpg";